import script from "./RequestDataCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDataCard.vue?vue&type=script&setup=true&lang=js"

import "./RequestDataCard.vue?vue&type=style&index=0&id=624d2fbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624d2fbf"]])

export default __exports__